import React from "react";

export const defaultWasteData = [
  // SECTION 1
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Plastic waste (A)",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "E-waste (B)",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Bio-medical waste (C)",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Construction and demolition waste (D)",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Battery waste (E)",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Radioactive waste (F)",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Other Hazardous waste. Please Specify, if any. (G)",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Other Non-hazardous waste generated (H)...",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Total (A+B + C + D + E + F + G + H)",
    isTotal: true,
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Waste intensity per rupee of turnover...",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Waste intensity per rupee of turnover adjusted for PPP...",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Waste intensity per rupee of turnover...",
    current: "",
    previous: "",
  },
  {
    section: "Total Waste generated (in metric tonnes)",
    label: "Waste intensity (optional)",
    current: "",
    previous: "",
  },

  // SECTION 2
  {
    section: "Recovered through recycling, re-using or other recovery",
    label: "(i) Recycled",
    current: "",
    previous: "",
  },
  {
    section: "Recovered through recycling, re-using or other recovery",
    label: "(ii) Re-used",
    current: "",
    previous: "",
  },
  {
    section: "Recovered through recycling, re-using or other recovery",
    label: "(iii) Other recovery operations",
    current: "",
    previous: "",
  },
  {
    section: "Recovered through recycling, re-using or other recovery",
    label: "Total",
    isTotal: true,
    current: "",
    previous: "",
  },

  // SECTION 3
  {
    section: "Disposed by nature of disposal method",
    label: "(i) Incineration",
    current: "",
    previous: "",
  },
  {
    section: "Disposed by nature of disposal method",
    label: "(ii) Landfilling",
    current: "",
    previous: "",
  },
  {
    section: "Disposed by nature of disposal method",
    label: "(iii) Other disposal operations",
    current: "",
    previous: "",
  },
  {
    section: "Disposed by nature of disposal method",
    label: "Total",
    isTotal: true,
    current: "",
    previous: "",
  },
];

const WasteManagementEntityTable = ({
  wasteManagementData = [],
  setWasteManagementData,
}) => {
  const flatData = wasteManagementData;

  const handleChange = (index, field, value) => {
    const updated = [...flatData];
    updated[index][field] = value;
    setWasteManagementData(updated);
  };

  const groupedData = flatData.reduce((acc, row, index) => {
    const section = row.section;
    if (!acc[section]) acc[section] = [];
    acc[section].push({ ...row, index });
    return acc;
  }, {});

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#d3c9ce", fontWeight: "bold" }}>
            <th style={headerStyle}>Parameter</th>
            <th style={headerStyle}>
              FY _____
              <br />
              Current Financial Year
            </th>
            <th style={headerStyle}>
              FY _____
              <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupedData).map(([section, rows], secIdx) => (
            <React.Fragment key={secIdx}>
              <tr>
                <td colSpan={3} style={sectionHeaderStyle}>
                  {section}
                </td>
              </tr>
              {rows.map((row) => (
                <tr key={row.label}>
                  <td
                    style={{
                      ...labelCellStyle,
                      fontWeight: row.isTotal ? "bold" : 500,
                    }}
                  >
                    {row.label}
                  </td>
                  <td style={cellStyle}>
                    <input
                      type="text"
                      placeholder="Current FY"
                      value={row.current}
                      onChange={(e) =>
                        handleChange(row.index, "current", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                  <td style={cellStyle}>
                    <input
                      type="text"
                      placeholder="Previous FY"
                      value={row.previous}
                      onChange={(e) =>
                        handleChange(row.index, "previous", e.target.value)
                      }
                      style={inputStyle}
                    />
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  backgroundColor: "#d3c9ce",
};

const sectionHeaderStyle = {
  backgroundColor: "#d3c9ce",
  fontWeight: "bold",
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const labelCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  backgroundColor: "#f4edf0",
  textAlign: "left",
  whiteSpace: "normal",
  width: "40%",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "85%",
  padding: "8px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "4px",
  outline: "none",
};

export default WasteManagementEntityTable;
